export default __webpack_public_path__ + "../staticImages/fallback-rebsorten.jpg";